/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getSurgicalAppointments } from 'app/entities/surgical-appointment/surgical-appointment.reducer';
import { getEntities as getSurgicalAppointmentAttributeTypes } from 'app/entities/surgical-appointment-attribute-type/surgical-appointment-attribute-type.reducer';
import { UserType } from 'app/shared/model/enumerations/user-type.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';
import { createEntity, getEntity, reset, updateEntity } from './surgical-appointment-attribute.reducer';

export const SurgicalAppointmentAttributeUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const surgicalAppointments = useAppSelector(state => state.surgicalAppointment.entities);
  const surgicalAppointmentAttributeTypes = useAppSelector(state => state.surgicalAppointmentAttributeType.entities);
  const surgicalAppointmentAttributeEntity = useAppSelector(state => state.surgicalAppointmentAttribute.entity);
  const loading = useAppSelector(state => state.surgicalAppointmentAttribute.loading);
  const updating = useAppSelector(state => state.surgicalAppointmentAttribute.updating);
  const updateSuccess = useAppSelector(state => state.surgicalAppointmentAttribute.updateSuccess);
  const userTypeValues = Object.keys(UserType);
  const addedByTypeValues = Object.keys(AddedByType);

  const handleClose = () => {
    navigate(`/surgical-appointment-attribute${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getSurgicalAppointments({}));
    dispatch(getSurgicalAppointmentAttributeTypes({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...surgicalAppointmentAttributeEntity,
      ...values,
      schedule: surgicalAppointments.find(it => it.id.toString() === values.schedule?.toString()),
      attributeType: surgicalAppointmentAttributeTypes.find(it => it.id.toString() === values.attributeType?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          participantType: 'DOCTOR',
          addedByType: 'DOCTOR',
          modifiedByType: 'DOCTOR',
          ...surgicalAppointmentAttributeEntity,
          schedule: surgicalAppointmentAttributeEntity?.schedule?.id,
          attributeType: surgicalAppointmentAttributeEntity?.attributeType?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="tinyMedicRestApp.surgicalAppointmentAttribute.home.createOrEditLabel"
            data-cy="SurgicalAppointmentAttributeCreateUpdateHeading"
          >
            <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttribute.home.createOrEditLabel">
              Create or edit a SurgicalAppointmentAttribute
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="surgical-appointment-attribute-id"
                  label={translate('tinyMedicRestApp.surgicalAppointmentAttribute.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointmentAttribute.value')}
                id="surgical-appointment-attribute-value"
                name="value"
                data-cy="value"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointmentAttribute.participantType')}
                id="surgical-appointment-attribute-participantType"
                name="participantType"
                data-cy="participantType"
                type="select"
              >
                {userTypeValues.map(userType => (
                  <option value={userType} key={userType}>
                    {translate(`tinyMedicRestApp.UserType.${userType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointmentAttribute.participantId')}
                id="surgical-appointment-attribute-participantId"
                name="participantId"
                data-cy="participantId"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointmentAttribute.active')}
                id="surgical-appointment-attribute-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointmentAttribute.cursor')}
                id="surgical-appointment-attribute-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointmentAttribute.lastupdated')}
                id="surgical-appointment-attribute-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointmentAttribute.microSec')}
                id="surgical-appointment-attribute-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointmentAttribute.timestampentry')}
                id="surgical-appointment-attribute-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointmentAttribute.addedById')}
                id="surgical-appointment-attribute-addedById"
                name="addedById"
                data-cy="addedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointmentAttribute.modifiedById')}
                id="surgical-appointment-attribute-modifiedById"
                name="modifiedById"
                data-cy="modifiedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointmentAttribute.addedByType')}
                id="surgical-appointment-attribute-addedByType"
                name="addedByType"
                data-cy="addedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointmentAttribute.modifiedByType')}
                id="surgical-appointment-attribute-modifiedByType"
                name="modifiedByType"
                data-cy="modifiedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointmentAttribute.role')}
                id="surgical-appointment-attribute-role"
                name="role"
                data-cy="role"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                id="surgical-appointment-attribute-schedule"
                name="schedule"
                data-cy="schedule"
                label={translate('tinyMedicRestApp.surgicalAppointmentAttribute.schedule')}
                type="select"
                required
              >
                <option value="" key="0" />
                {surgicalAppointments
                  ? surgicalAppointments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="surgical-appointment-attribute-attributeType"
                name="attributeType"
                data-cy="attributeType"
                label={translate('tinyMedicRestApp.surgicalAppointmentAttribute.attributeType')}
                type="select"
              >
                <option value="" key="0" />
                {surgicalAppointmentAttributeTypes
                  ? surgicalAppointmentAttributeTypes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/surgical-appointment-attribute"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default SurgicalAppointmentAttributeUpdate;
